<template>
  <div :id="filterProp.id" class="filter-pill">
    {{ filterProp.content }}
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 9L12 15L5 9"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    filterProp: {
      type: Object,
      default: null,
    },
  },
  emits: ["isReady"],
  mounted() {
    this.$emit("isReady");
  },
};
</script>

<style sceopd>
.filter-pill {
  border-radius: 24px;
  color: var(--color-tag-bg);
  text-align: center;

  /* Body Small Strong */
  font-size: var(--typography-body-size-small);
  font-style: normal;
  font-family: var(--weight-700);
  letter-spacing: 0.64px;
  line-height: 140%; /* 19.6px */
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
}
.filter-pill svg path {
  stroke: var(--color-tag-bg);
}

@media(max-width: 768px) {  /* for test */
.filter-pill {
  margin-right: 8px;
  background: var(--color-background-default-default);
}
}
</style>
